import initGoogleMap from './elements/google-map';
import initHeader from './layout/header';
import initFaqBlock from './blocks/faq';
import initSideMenu from './blocks/side-menu';

waitForJQuery();

function waitForJQuery() {
    if (window.jQuery) {
        init();
    } else {
        setTimeout(waitForJQuery, 50);
    }
}

function init() {
    initHeader();
    initFaqBlock();
    initSideMenu();
    initGoogleMap();
}
